import React, { useState, useEffect } from 'react';
import Img from './styles';

import BlankImage from './assets/BLANK.png';
import { getAssetImage } from 'utils/assetImage';

const Brand = ({ src, name, ...otherProps }) => {
  const [image, setImage] = useState(src);

  useEffect(() => {
    if (src) {
      setImage(src);
    } else {
      const getImage = async () => {
        const base64Image = await getAssetImage(name);
        setImage(base64Image);
      }
      getImage();
    }
  }, [src]);


  return (
    <Img src={image || BlankImage} alt={name} {...otherProps} />
  )
};


export default Brand;
